module.exports = __webpack_public_path__ + "assets/img/img5.7d3d8036.png";